import React from "react";
import { LuNewspaper } from "react-icons/lu";
import { useRoleColor } from "../helper/roleHelper";

const StaticCard = ({
  cardHeader,
  cardSubHeader,
  cardIcon,
  cardNumber,
  description,
  cardColor,
  isCenter,
}) => {
  const { mainColor, errorColor } = useRoleColor();

  return (
    <>
      <div
        className={
          isCenter
            ? "h-full relative rounded-lg md:col-[2/3]"
            : "h-full relative rounded-lg"
        }
      >
        <div
          className="flex gap-2 items-center box-header top-2 w-full py-3 px-4 rounded-md absolute -right-4 text-white"
          style={{
            backgroundColor: cardColor === "blue" ? mainColor : errorColor,
          }}
        >
          <LuNewspaper />
          {cardHeader}
          {cardSubHeader && (
            <span className="text-[12px]">{cardSubHeader}</span>
          )}
        </div>
        <div className="box-list bg-white flex flex-col gap-2 pt-20 p-4 rounded-md min-h-60">
          <div className=" flex justify-between  rounded-lg items-center p-4">
            <div className="flex flex-col gap-4 items-start  text-sm w-full">
              <span className="text-[25px]">{cardNumber}</span>
              <span className="text-[20px] text-gray-500">{description}</span>
            </div>
            <div className=" flex justify-between bg-white rounded-lg items-center p-4">
              <div className="flex gap-2 items-center  text-sm w-full">
                <img src={cardIcon} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default StaticCard;
